import service from '@/utils/server';
let modelPath = '/h5/visitorLogin';
export const getVisitorLogin = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post'
    })
};



// WEBPACK FOOTER //
// ./src/page/visitor/visitorLogin/api/index.js